import React from 'react';

import Skeleton from '../components/Skeleton';
import Article from '../components/Article';

function About() {
  return (
    <Skeleton>
      <Article.T title="About">
        <Article.P>
          I'm Jake Kinsella — software architect and entrepreneur. I'm Co-Founder and Lead Architect at{' '}
          <a href="https://www.latentspin.ai" target="_blank" rel="noreferrer">LatentSpin</a>,
          where we're building agents that learn from teaching: in-model continual learning so expert work compounds into durable operational intelligence.
        </Article.P>

        <Article.P>
          LatentSpin is in stealth with a team of eight, all from the original core team at ChaosSearch, where I spent the first six years of my career as a senior engineer and tech lead.
        </Article.P>

        <Article.P>
          I've been programming for most of my life — I learned Ruby in fourth grade and never really stopped. I studied CS at Northeastern, interned across Boston startups, and caught the startup bug early. The rest is in my{' '}
          <a href="https://jakekinsella-portfolio.s3.amazonaws.com/Resume.pdf" target="_blank" rel="noreferrer">resume</a>.
        </Article.P>

        <Article.P>
          <a href="https://www.linkedin.com/in/jake-kinsella/" target="_blank" rel="noreferrer">LinkedIn</a><br />
          <a href="https://github.com/jakekinsella" target="_blank" rel="noreferrer">Personal GitHub</a><br />
          <a href="https://github.com/jake-kinsella" target="_blank" rel="noreferrer">Work GitHub</a>
        </Article.P>

        <img src="https://jakekinsella-portfolio.s3.amazonaws.com/images/jake.jpg" alt="Jake Kinsella" width="100%" />
      </Article.T>
    </Skeleton>
  );
}

export default About;
